/* tslint:disable */
/* eslint-disable */
/**
 * Citrus API Reference
 * Complete reference documentation for the Citrus API.
 *
 * The version of the OpenAPI document: 0.112.0
 * Contact: info@citruscamps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BatchMembershipOperation,
    BatchMembershipOperationFromJSON,
    BatchMembershipOperationToJSON,
    ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    Gender,
    GenderFromJSON,
    GenderToJSON,
    GetManyOrder,
    GetManyOrderFromJSON,
    GetManyOrderToJSON,
    Membership,
    MembershipFromJSON,
    MembershipToJSON,
    MembershipBulkParams,
    MembershipBulkParamsFromJSON,
    MembershipBulkParamsToJSON,
    MembershipCreateParams,
    MembershipCreateParamsFromJSON,
    MembershipCreateParamsToJSON,
    MembershipList,
    MembershipListFromJSON,
    MembershipListToJSON,
    MembershipPackage,
    MembershipPackageFromJSON,
    MembershipPackageToJSON,
    MembershipPackageCreateParams,
    MembershipPackageCreateParamsFromJSON,
    MembershipPackageCreateParamsToJSON,
    MembershipPackageDiscontinueParams,
    MembershipPackageDiscontinueParamsFromJSON,
    MembershipPackageDiscontinueParamsToJSON,
    MembershipPackageList,
    MembershipPackageListFromJSON,
    MembershipPackageListToJSON,
    MembershipPatchParams,
    MembershipPatchParamsFromJSON,
    MembershipPatchParamsToJSON,
    MembershipStatus,
    MembershipStatusFromJSON,
    MembershipStatusToJSON,
    MembershipUpdateParams,
    MembershipUpdateParamsFromJSON,
    MembershipUpdateParamsToJSON,
    SessionCredit,
    SessionCreditFromJSON,
    SessionCreditToJSON,
    SessionCreditCreateParams,
    SessionCreditCreateParamsFromJSON,
    SessionCreditCreateParamsToJSON,
    SessionCreditList,
    SessionCreditListFromJSON,
    SessionCreditListToJSON,
    SessionCreditsUpdatedBalance,
    SessionCreditsUpdatedBalanceFromJSON,
    SessionCreditsUpdatedBalanceToJSON,
    SessionPackage,
    SessionPackageFromJSON,
    SessionPackageToJSON,
    SessionPackageCreateParams,
    SessionPackageCreateParamsFromJSON,
    SessionPackageCreateParamsToJSON,
    SessionPackageList,
    SessionPackageListFromJSON,
    SessionPackageListToJSON,
    SuccessResponse,
    SuccessResponseFromJSON,
    SuccessResponseToJSON,
} from '../models';

export interface CancelMembershipRequest {
    program_id: string;
    membership_id: string;
}

export interface CreateMembershipRequest {
    program_id: string;
    MembershipCreateParams: MembershipCreateParams;
}

export interface CreateMembershipPackageRequest {
    program_id: string;
    MembershipPackageCreateParams: MembershipPackageCreateParams;
}

export interface CreateSessionCreditRequest {
    program_id: string;
    SessionCreditCreateParams: SessionCreditCreateParams;
}

export interface CreateSessionPackageRequest {
    program_id: string;
    SessionPackageCreateParams: SessionPackageCreateParams;
}

export interface DeleteMembershipPackageRequest {
    program_id: string;
    membership_package_id: string;
}

export interface DeleteSessionCreditRequest {
    program_id: string;
    session_credit_id: string;
}

export interface DeleteSessionPackageRequest {
    program_id: string;
    session_package_id: string;
}

export interface DiscontinueMembershipPackageRequest {
    program_id: string;
    membership_package_id: string;
    MembershipPackageDiscontinueParams: MembershipPackageDiscontinueParams;
}

export interface DiscontinueSessionPackageRequest {
    program_id: string;
    session_package_id: string;
}

export interface FindMembershipPackagesRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    id?: Array<string>;
    exclude_id?: Array<string>;
    is_discontinued?: boolean;
    program_attendee_id?: string;
    status?: Array<MembershipStatus>;
}

export interface FindMembershipsRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    id?: Array<string>;
    exclude_id?: Array<string>;
    contact_id?: string;
    program_attendee_id?: string;
    package_id?: Array<string>;
    status?: Array<MembershipStatus>;
    attendee_gender?: Array<Gender>;
    billing_day?: number;
    billing_month?: number;
    trialing_lt?: Date;
    trialing_gt?: Date;
    trialing_lte?: Date;
    trialing_gte?: Date;
    start_date_lt?: Date;
    start_date_gt?: Date;
    start_date_lte?: Date;
    start_date_gte?: Date;
    cancel_at_lt?: Date;
    cancel_at_gt?: Date;
    cancel_at_lte?: Date;
    cancel_at_gte?: Date;
    created_lt?: Date;
    created_gt?: Date;
    created_lte?: Date;
    created_gte?: Date;
    updated_lt?: Date;
    updated_gt?: Date;
    updated_lte?: Date;
    updated_gte?: Date;
}

export interface FindOneMembershipRequest {
    program_id: string;
    membership_id: string;
}

export interface FindOneMembershipPackageRequest {
    program_id: string;
    membership_package_id: string;
}

export interface FindOneSessionCreditRequest {
    program_id: string;
    session_credit_id: string;
}

export interface FindOneSessionPackageRequest {
    program_id: string;
    session_package_id: string;
}

export interface FindSessionCreditsRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    contact_id?: string;
}

export interface FindSessionPackagesRequest {
    program_id: string;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    id?: Array<string>;
    is_discontinued?: boolean;
}

export interface PatchBulkMembershipRequest {
    program_id: string;
    MembershipBulkParams: MembershipBulkParams;
    limit?: number;
    skip?: number;
    order?: GetManyOrder;
    sort?: string;
    search?: string;
    id?: Array<string>;
    exclude_id?: Array<string>;
    contact_id?: string;
    program_attendee_id?: string;
    package_id?: Array<string>;
    status?: Array<MembershipStatus>;
    attendee_gender?: Array<Gender>;
}

export interface PatchMembershipRequest {
    program_id: string;
    membership_id: string;
    MembershipPatchParams: MembershipPatchParams;
}

export interface RecontinueMembershipPackageRequest {
    program_id: string;
    membership_package_id: string;
}

export interface RecontinueSessionPackageRequest {
    program_id: string;
    session_package_id: string;
}

export interface UndoVoidSessionCreditRequest {
    program_id: string;
    session_credit_id: string;
}

export interface UpdateMembershipRequest {
    program_id: string;
    membership_id: string;
    MembershipUpdateParams: MembershipUpdateParams;
}

export interface UpdateMembershipPackageRequest {
    program_id: string;
    membership_package_id: string;
    MembershipPackage: MembershipPackage;
}

export interface UpdateSessionCreditRequest {
    program_id: string;
    session_credit_id: string;
    SessionCredit: SessionCredit;
}

export interface UpdateSessionPackageRequest {
    program_id: string;
    session_package_id: string;
    SessionPackage: SessionPackage;
}

export interface VoidSessionCreditRequest {
    program_id: string;
    session_credit_id: string;
}

/**
 * 
 */
export class SessionsApi extends runtime.BaseAPI {

    /**
     * Cancel membership
     */
    async cancelMembershipRaw(requestParameters: CancelMembershipRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling cancelMembership.');
        }

        if (requestParameters.membership_id === null || requestParameters.membership_id === undefined) {
            throw new runtime.RequiredError('membership_id','Required parameter requestParameters.membership_id was null or undefined when calling cancelMembership.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/memberships/{membership_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"membership_id"}}`, encodeURIComponent(String(requestParameters.membership_id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Cancel membership
     */
    async cancelMembership(requestParameters: CancelMembershipRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.cancelMembershipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create membership
     */
    async createMembershipRaw(requestParameters: CreateMembershipRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Membership>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createMembership.');
        }

        if (requestParameters.MembershipCreateParams === null || requestParameters.MembershipCreateParams === undefined) {
            throw new runtime.RequiredError('MembershipCreateParams','Required parameter requestParameters.MembershipCreateParams was null or undefined when calling createMembership.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/memberships`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MembershipCreateParamsToJSON(requestParameters.MembershipCreateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MembershipFromJSON(jsonValue));
    }

    /**
     * Create membership
     */
    async createMembership(requestParameters: CreateMembershipRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Membership> {
        const response = await this.createMembershipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create membership package
     */
    async createMembershipPackageRaw(requestParameters: CreateMembershipPackageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<MembershipPackage>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createMembershipPackage.');
        }

        if (requestParameters.MembershipPackageCreateParams === null || requestParameters.MembershipPackageCreateParams === undefined) {
            throw new runtime.RequiredError('MembershipPackageCreateParams','Required parameter requestParameters.MembershipPackageCreateParams was null or undefined when calling createMembershipPackage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/membership_packages`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MembershipPackageCreateParamsToJSON(requestParameters.MembershipPackageCreateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MembershipPackageFromJSON(jsonValue));
    }

    /**
     * Create membership package
     */
    async createMembershipPackage(requestParameters: CreateMembershipPackageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<MembershipPackage> {
        const response = await this.createMembershipPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create session credit
     */
    async createSessionCreditRaw(requestParameters: CreateSessionCreditRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SessionCreditsUpdatedBalance>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createSessionCredit.');
        }

        if (requestParameters.SessionCreditCreateParams === null || requestParameters.SessionCreditCreateParams === undefined) {
            throw new runtime.RequiredError('SessionCreditCreateParams','Required parameter requestParameters.SessionCreditCreateParams was null or undefined when calling createSessionCredit.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/session_credits`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SessionCreditCreateParamsToJSON(requestParameters.SessionCreditCreateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionCreditsUpdatedBalanceFromJSON(jsonValue));
    }

    /**
     * Create session credit
     */
    async createSessionCredit(requestParameters: CreateSessionCreditRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SessionCreditsUpdatedBalance> {
        const response = await this.createSessionCreditRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create session-package
     */
    async createSessionPackageRaw(requestParameters: CreateSessionPackageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SessionPackage>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling createSessionPackage.');
        }

        if (requestParameters.SessionPackageCreateParams === null || requestParameters.SessionPackageCreateParams === undefined) {
            throw new runtime.RequiredError('SessionPackageCreateParams','Required parameter requestParameters.SessionPackageCreateParams was null or undefined when calling createSessionPackage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/session_packages`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SessionPackageCreateParamsToJSON(requestParameters.SessionPackageCreateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionPackageFromJSON(jsonValue));
    }

    /**
     * Create session-package
     */
    async createSessionPackage(requestParameters: CreateSessionPackageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SessionPackage> {
        const response = await this.createSessionPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete membership package
     */
    async deleteMembershipPackageRaw(requestParameters: DeleteMembershipPackageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling deleteMembershipPackage.');
        }

        if (requestParameters.membership_package_id === null || requestParameters.membership_package_id === undefined) {
            throw new runtime.RequiredError('membership_package_id','Required parameter requestParameters.membership_package_id was null or undefined when calling deleteMembershipPackage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/membership_packages/{membership_package_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"membership_package_id"}}`, encodeURIComponent(String(requestParameters.membership_package_id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Delete membership package
     */
    async deleteMembershipPackage(requestParameters: DeleteMembershipPackageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.deleteMembershipPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete session credit
     */
    async deleteSessionCreditRaw(requestParameters: DeleteSessionCreditRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling deleteSessionCredit.');
        }

        if (requestParameters.session_credit_id === null || requestParameters.session_credit_id === undefined) {
            throw new runtime.RequiredError('session_credit_id','Required parameter requestParameters.session_credit_id was null or undefined when calling deleteSessionCredit.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/session_credits/{session_credit_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"session_credit_id"}}`, encodeURIComponent(String(requestParameters.session_credit_id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Delete session credit
     */
    async deleteSessionCredit(requestParameters: DeleteSessionCreditRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.deleteSessionCreditRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete session-package
     */
    async deleteSessionPackageRaw(requestParameters: DeleteSessionPackageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SuccessResponse>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling deleteSessionPackage.');
        }

        if (requestParameters.session_package_id === null || requestParameters.session_package_id === undefined) {
            throw new runtime.RequiredError('session_package_id','Required parameter requestParameters.session_package_id was null or undefined when calling deleteSessionPackage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/session_packages/{session_package_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"session_package_id"}}`, encodeURIComponent(String(requestParameters.session_package_id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SuccessResponseFromJSON(jsonValue));
    }

    /**
     * Delete session-package
     */
    async deleteSessionPackage(requestParameters: DeleteSessionPackageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SuccessResponse> {
        const response = await this.deleteSessionPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Discontinue a membership package
     */
    async discontinueMembershipPackageRaw(requestParameters: DiscontinueMembershipPackageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<MembershipPackage>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling discontinueMembershipPackage.');
        }

        if (requestParameters.membership_package_id === null || requestParameters.membership_package_id === undefined) {
            throw new runtime.RequiredError('membership_package_id','Required parameter requestParameters.membership_package_id was null or undefined when calling discontinueMembershipPackage.');
        }

        if (requestParameters.MembershipPackageDiscontinueParams === null || requestParameters.MembershipPackageDiscontinueParams === undefined) {
            throw new runtime.RequiredError('MembershipPackageDiscontinueParams','Required parameter requestParameters.MembershipPackageDiscontinueParams was null or undefined when calling discontinueMembershipPackage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/membership_packages/{membership_package_id}/discontinue`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"membership_package_id"}}`, encodeURIComponent(String(requestParameters.membership_package_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: MembershipPackageDiscontinueParamsToJSON(requestParameters.MembershipPackageDiscontinueParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MembershipPackageFromJSON(jsonValue));
    }

    /**
     * Discontinue a membership package
     */
    async discontinueMembershipPackage(requestParameters: DiscontinueMembershipPackageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<MembershipPackage> {
        const response = await this.discontinueMembershipPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Discontinue a session package
     */
    async discontinueSessionPackageRaw(requestParameters: DiscontinueSessionPackageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SessionPackage>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling discontinueSessionPackage.');
        }

        if (requestParameters.session_package_id === null || requestParameters.session_package_id === undefined) {
            throw new runtime.RequiredError('session_package_id','Required parameter requestParameters.session_package_id was null or undefined when calling discontinueSessionPackage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/session_packages/{session_package_id}/discontinue`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"session_package_id"}}`, encodeURIComponent(String(requestParameters.session_package_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionPackageFromJSON(jsonValue));
    }

    /**
     * Discontinue a session package
     */
    async discontinueSessionPackage(requestParameters: DiscontinueSessionPackageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SessionPackage> {
        const response = await this.discontinueSessionPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all membership packages
     */
    async findMembershipPackagesRaw(requestParameters: FindMembershipPackagesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<MembershipPackageList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findMembershipPackages.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.exclude_id) {
            queryParameters['exclude_id'] = requestParameters.exclude_id;
        }

        if (requestParameters.is_discontinued !== undefined) {
            queryParameters['is_discontinued'] = requestParameters.is_discontinued;
        }

        if (requestParameters.program_attendee_id !== undefined) {
            queryParameters['program_attendee_id'] = requestParameters.program_attendee_id;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/membership_packages`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MembershipPackageListFromJSON(jsonValue));
    }

    /**
     * List all membership packages
     */
    async findMembershipPackages(requestParameters: FindMembershipPackagesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<MembershipPackageList> {
        const response = await this.findMembershipPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all memberships
     */
    async findMembershipsRaw(requestParameters: FindMembershipsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<MembershipList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findMemberships.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.exclude_id) {
            queryParameters['exclude_id'] = requestParameters.exclude_id;
        }

        if (requestParameters.contact_id !== undefined) {
            queryParameters['contact_id'] = requestParameters.contact_id;
        }

        if (requestParameters.program_attendee_id !== undefined) {
            queryParameters['program_attendee_id'] = requestParameters.program_attendee_id;
        }

        if (requestParameters.package_id) {
            queryParameters['package_id'] = requestParameters.package_id;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.attendee_gender) {
            queryParameters['attendee_gender'] = requestParameters.attendee_gender;
        }

        if (requestParameters.billing_day !== undefined) {
            queryParameters['billing_day'] = requestParameters.billing_day;
        }

        if (requestParameters.billing_month !== undefined) {
            queryParameters['billing_month'] = requestParameters.billing_month;
        }

        if (requestParameters.trialing_lt !== undefined) {
            queryParameters['trialing_lt'] = (requestParameters.trialing_lt as any).toISOString();
        }

        if (requestParameters.trialing_gt !== undefined) {
            queryParameters['trialing_gt'] = (requestParameters.trialing_gt as any).toISOString();
        }

        if (requestParameters.trialing_lte !== undefined) {
            queryParameters['trialing_lte'] = (requestParameters.trialing_lte as any).toISOString();
        }

        if (requestParameters.trialing_gte !== undefined) {
            queryParameters['trialing_gte'] = (requestParameters.trialing_gte as any).toISOString();
        }

        if (requestParameters.start_date_lt !== undefined) {
            queryParameters['start_date_lt'] = (requestParameters.start_date_lt as any).toISOString();
        }

        if (requestParameters.start_date_gt !== undefined) {
            queryParameters['start_date_gt'] = (requestParameters.start_date_gt as any).toISOString();
        }

        if (requestParameters.start_date_lte !== undefined) {
            queryParameters['start_date_lte'] = (requestParameters.start_date_lte as any).toISOString();
        }

        if (requestParameters.start_date_gte !== undefined) {
            queryParameters['start_date_gte'] = (requestParameters.start_date_gte as any).toISOString();
        }

        if (requestParameters.cancel_at_lt !== undefined) {
            queryParameters['cancel_at_lt'] = (requestParameters.cancel_at_lt as any).toISOString();
        }

        if (requestParameters.cancel_at_gt !== undefined) {
            queryParameters['cancel_at_gt'] = (requestParameters.cancel_at_gt as any).toISOString();
        }

        if (requestParameters.cancel_at_lte !== undefined) {
            queryParameters['cancel_at_lte'] = (requestParameters.cancel_at_lte as any).toISOString();
        }

        if (requestParameters.cancel_at_gte !== undefined) {
            queryParameters['cancel_at_gte'] = (requestParameters.cancel_at_gte as any).toISOString();
        }

        if (requestParameters.created_lt !== undefined) {
            queryParameters['created_lt'] = (requestParameters.created_lt as any).toISOString();
        }

        if (requestParameters.created_gt !== undefined) {
            queryParameters['created_gt'] = (requestParameters.created_gt as any).toISOString();
        }

        if (requestParameters.created_lte !== undefined) {
            queryParameters['created_lte'] = (requestParameters.created_lte as any).toISOString();
        }

        if (requestParameters.created_gte !== undefined) {
            queryParameters['created_gte'] = (requestParameters.created_gte as any).toISOString();
        }

        if (requestParameters.updated_lt !== undefined) {
            queryParameters['updated_lt'] = (requestParameters.updated_lt as any).toISOString();
        }

        if (requestParameters.updated_gt !== undefined) {
            queryParameters['updated_gt'] = (requestParameters.updated_gt as any).toISOString();
        }

        if (requestParameters.updated_lte !== undefined) {
            queryParameters['updated_lte'] = (requestParameters.updated_lte as any).toISOString();
        }

        if (requestParameters.updated_gte !== undefined) {
            queryParameters['updated_gte'] = (requestParameters.updated_gte as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/memberships`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MembershipListFromJSON(jsonValue));
    }

    /**
     * List all memberships
     */
    async findMemberships(requestParameters: FindMembershipsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<MembershipList> {
        const response = await this.findMembershipsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find membership by id
     */
    async findOneMembershipRaw(requestParameters: FindOneMembershipRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Membership>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneMembership.');
        }

        if (requestParameters.membership_id === null || requestParameters.membership_id === undefined) {
            throw new runtime.RequiredError('membership_id','Required parameter requestParameters.membership_id was null or undefined when calling findOneMembership.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/memberships/{membership_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"membership_id"}}`, encodeURIComponent(String(requestParameters.membership_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MembershipFromJSON(jsonValue));
    }

    /**
     * Find membership by id
     */
    async findOneMembership(requestParameters: FindOneMembershipRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Membership> {
        const response = await this.findOneMembershipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find membership package by id
     */
    async findOneMembershipPackageRaw(requestParameters: FindOneMembershipPackageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<MembershipPackage>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneMembershipPackage.');
        }

        if (requestParameters.membership_package_id === null || requestParameters.membership_package_id === undefined) {
            throw new runtime.RequiredError('membership_package_id','Required parameter requestParameters.membership_package_id was null or undefined when calling findOneMembershipPackage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/membership_packages/{membership_package_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"membership_package_id"}}`, encodeURIComponent(String(requestParameters.membership_package_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MembershipPackageFromJSON(jsonValue));
    }

    /**
     * Find membership package by id
     */
    async findOneMembershipPackage(requestParameters: FindOneMembershipPackageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<MembershipPackage> {
        const response = await this.findOneMembershipPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find session credit by id
     */
    async findOneSessionCreditRaw(requestParameters: FindOneSessionCreditRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SessionCredit>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneSessionCredit.');
        }

        if (requestParameters.session_credit_id === null || requestParameters.session_credit_id === undefined) {
            throw new runtime.RequiredError('session_credit_id','Required parameter requestParameters.session_credit_id was null or undefined when calling findOneSessionCredit.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/session_credits/{session_credit_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"session_credit_id"}}`, encodeURIComponent(String(requestParameters.session_credit_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionCreditFromJSON(jsonValue));
    }

    /**
     * Find session credit by id
     */
    async findOneSessionCredit(requestParameters: FindOneSessionCreditRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SessionCredit> {
        const response = await this.findOneSessionCreditRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Find session-package by id
     */
    async findOneSessionPackageRaw(requestParameters: FindOneSessionPackageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SessionPackage>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findOneSessionPackage.');
        }

        if (requestParameters.session_package_id === null || requestParameters.session_package_id === undefined) {
            throw new runtime.RequiredError('session_package_id','Required parameter requestParameters.session_package_id was null or undefined when calling findOneSessionPackage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/session_packages/{session_package_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"session_package_id"}}`, encodeURIComponent(String(requestParameters.session_package_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionPackageFromJSON(jsonValue));
    }

    /**
     * Find session-package by id
     */
    async findOneSessionPackage(requestParameters: FindOneSessionPackageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SessionPackage> {
        const response = await this.findOneSessionPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all session credits
     */
    async findSessionCreditsRaw(requestParameters: FindSessionCreditsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SessionCreditList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findSessionCredits.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.contact_id !== undefined) {
            queryParameters['contact_id'] = requestParameters.contact_id;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/session_credits`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionCreditListFromJSON(jsonValue));
    }

    /**
     * List all session credits
     */
    async findSessionCredits(requestParameters: FindSessionCreditsRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SessionCreditList> {
        const response = await this.findSessionCreditsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * List all session-package
     */
    async findSessionPackagesRaw(requestParameters: FindSessionPackagesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SessionPackageList>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling findSessionPackages.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.is_discontinued !== undefined) {
            queryParameters['is_discontinued'] = requestParameters.is_discontinued;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/session_packages`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionPackageListFromJSON(jsonValue));
    }

    /**
     * List all session-package
     */
    async findSessionPackages(requestParameters: FindSessionPackagesRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SessionPackageList> {
        const response = await this.findSessionPackagesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch memberships in bulk
     */
    async patchBulkMembershipRaw(requestParameters: PatchBulkMembershipRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<BatchMembershipOperation>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling patchBulkMembership.');
        }

        if (requestParameters.MembershipBulkParams === null || requestParameters.MembershipBulkParams === undefined) {
            throw new runtime.RequiredError('MembershipBulkParams','Required parameter requestParameters.MembershipBulkParams was null or undefined when calling patchBulkMembership.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.skip !== undefined) {
            queryParameters['skip'] = requestParameters.skip;
        }

        if (requestParameters.order !== undefined) {
            queryParameters['order'] = requestParameters.order;
        }

        if (requestParameters.sort !== undefined) {
            queryParameters['sort'] = requestParameters.sort;
        }

        if (requestParameters.search !== undefined) {
            queryParameters['search'] = requestParameters.search;
        }

        if (requestParameters.id) {
            queryParameters['id'] = requestParameters.id;
        }

        if (requestParameters.exclude_id) {
            queryParameters['exclude_id'] = requestParameters.exclude_id;
        }

        if (requestParameters.contact_id !== undefined) {
            queryParameters['contact_id'] = requestParameters.contact_id;
        }

        if (requestParameters.program_attendee_id !== undefined) {
            queryParameters['program_attendee_id'] = requestParameters.program_attendee_id;
        }

        if (requestParameters.package_id) {
            queryParameters['package_id'] = requestParameters.package_id;
        }

        if (requestParameters.status) {
            queryParameters['status'] = requestParameters.status;
        }

        if (requestParameters.attendee_gender) {
            queryParameters['attendee_gender'] = requestParameters.attendee_gender;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/memberships`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: MembershipBulkParamsToJSON(requestParameters.MembershipBulkParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BatchMembershipOperationFromJSON(jsonValue));
    }

    /**
     * Patch memberships in bulk
     */
    async patchBulkMembership(requestParameters: PatchBulkMembershipRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<BatchMembershipOperation> {
        const response = await this.patchBulkMembershipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Patch a membership for program
     */
    async patchMembershipRaw(requestParameters: PatchMembershipRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Membership>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling patchMembership.');
        }

        if (requestParameters.membership_id === null || requestParameters.membership_id === undefined) {
            throw new runtime.RequiredError('membership_id','Required parameter requestParameters.membership_id was null or undefined when calling patchMembership.');
        }

        if (requestParameters.MembershipPatchParams === null || requestParameters.MembershipPatchParams === undefined) {
            throw new runtime.RequiredError('MembershipPatchParams','Required parameter requestParameters.MembershipPatchParams was null or undefined when calling patchMembership.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/memberships/{membership_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"membership_id"}}`, encodeURIComponent(String(requestParameters.membership_id))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: MembershipPatchParamsToJSON(requestParameters.MembershipPatchParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MembershipFromJSON(jsonValue));
    }

    /**
     * Patch a membership for program
     */
    async patchMembership(requestParameters: PatchMembershipRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Membership> {
        const response = await this.patchMembershipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Recontinue a membership package
     */
    async recontinueMembershipPackageRaw(requestParameters: RecontinueMembershipPackageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<MembershipPackage>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling recontinueMembershipPackage.');
        }

        if (requestParameters.membership_package_id === null || requestParameters.membership_package_id === undefined) {
            throw new runtime.RequiredError('membership_package_id','Required parameter requestParameters.membership_package_id was null or undefined when calling recontinueMembershipPackage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/membership_packages/{membership_package_id}/recontinue`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"membership_package_id"}}`, encodeURIComponent(String(requestParameters.membership_package_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MembershipPackageFromJSON(jsonValue));
    }

    /**
     * Recontinue a membership package
     */
    async recontinueMembershipPackage(requestParameters: RecontinueMembershipPackageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<MembershipPackage> {
        const response = await this.recontinueMembershipPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Recontinue a session package
     */
    async recontinueSessionPackageRaw(requestParameters: RecontinueSessionPackageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SessionPackage>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling recontinueSessionPackage.');
        }

        if (requestParameters.session_package_id === null || requestParameters.session_package_id === undefined) {
            throw new runtime.RequiredError('session_package_id','Required parameter requestParameters.session_package_id was null or undefined when calling recontinueSessionPackage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/session_packages/{session_package_id}/recontinue`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"session_package_id"}}`, encodeURIComponent(String(requestParameters.session_package_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionPackageFromJSON(jsonValue));
    }

    /**
     * Recontinue a session package
     */
    async recontinueSessionPackage(requestParameters: RecontinueSessionPackageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SessionPackage> {
        const response = await this.recontinueSessionPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Undo void for a session credit
     */
    async undoVoidSessionCreditRaw(requestParameters: UndoVoidSessionCreditRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SessionCredit>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling undoVoidSessionCredit.');
        }

        if (requestParameters.session_credit_id === null || requestParameters.session_credit_id === undefined) {
            throw new runtime.RequiredError('session_credit_id','Required parameter requestParameters.session_credit_id was null or undefined when calling undoVoidSessionCredit.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/session_credits/{session_credit_id}/undo_void`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"session_credit_id"}}`, encodeURIComponent(String(requestParameters.session_credit_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionCreditFromJSON(jsonValue));
    }

    /**
     * Undo void for a session credit
     */
    async undoVoidSessionCredit(requestParameters: UndoVoidSessionCreditRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SessionCredit> {
        const response = await this.undoVoidSessionCreditRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update membership
     */
    async updateMembershipRaw(requestParameters: UpdateMembershipRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Membership>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling updateMembership.');
        }

        if (requestParameters.membership_id === null || requestParameters.membership_id === undefined) {
            throw new runtime.RequiredError('membership_id','Required parameter requestParameters.membership_id was null or undefined when calling updateMembership.');
        }

        if (requestParameters.MembershipUpdateParams === null || requestParameters.MembershipUpdateParams === undefined) {
            throw new runtime.RequiredError('MembershipUpdateParams','Required parameter requestParameters.MembershipUpdateParams was null or undefined when calling updateMembership.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/memberships/{membership_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"membership_id"}}`, encodeURIComponent(String(requestParameters.membership_id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MembershipUpdateParamsToJSON(requestParameters.MembershipUpdateParams),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MembershipFromJSON(jsonValue));
    }

    /**
     * Update membership
     */
    async updateMembership(requestParameters: UpdateMembershipRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Membership> {
        const response = await this.updateMembershipRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update membership package
     */
    async updateMembershipPackageRaw(requestParameters: UpdateMembershipPackageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<MembershipPackage>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling updateMembershipPackage.');
        }

        if (requestParameters.membership_package_id === null || requestParameters.membership_package_id === undefined) {
            throw new runtime.RequiredError('membership_package_id','Required parameter requestParameters.membership_package_id was null or undefined when calling updateMembershipPackage.');
        }

        if (requestParameters.MembershipPackage === null || requestParameters.MembershipPackage === undefined) {
            throw new runtime.RequiredError('MembershipPackage','Required parameter requestParameters.MembershipPackage was null or undefined when calling updateMembershipPackage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/membership_packages/{membership_package_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"membership_package_id"}}`, encodeURIComponent(String(requestParameters.membership_package_id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: MembershipPackageToJSON(requestParameters.MembershipPackage),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => MembershipPackageFromJSON(jsonValue));
    }

    /**
     * Update membership package
     */
    async updateMembershipPackage(requestParameters: UpdateMembershipPackageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<MembershipPackage> {
        const response = await this.updateMembershipPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update session credit
     */
    async updateSessionCreditRaw(requestParameters: UpdateSessionCreditRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SessionCredit>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling updateSessionCredit.');
        }

        if (requestParameters.session_credit_id === null || requestParameters.session_credit_id === undefined) {
            throw new runtime.RequiredError('session_credit_id','Required parameter requestParameters.session_credit_id was null or undefined when calling updateSessionCredit.');
        }

        if (requestParameters.SessionCredit === null || requestParameters.SessionCredit === undefined) {
            throw new runtime.RequiredError('SessionCredit','Required parameter requestParameters.SessionCredit was null or undefined when calling updateSessionCredit.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/session_credits/{session_credit_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"session_credit_id"}}`, encodeURIComponent(String(requestParameters.session_credit_id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SessionCreditToJSON(requestParameters.SessionCredit),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionCreditFromJSON(jsonValue));
    }

    /**
     * Update session credit
     */
    async updateSessionCredit(requestParameters: UpdateSessionCreditRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SessionCredit> {
        const response = await this.updateSessionCreditRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update session-package
     */
    async updateSessionPackageRaw(requestParameters: UpdateSessionPackageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SessionPackage>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling updateSessionPackage.');
        }

        if (requestParameters.session_package_id === null || requestParameters.session_package_id === undefined) {
            throw new runtime.RequiredError('session_package_id','Required parameter requestParameters.session_package_id was null or undefined when calling updateSessionPackage.');
        }

        if (requestParameters.SessionPackage === null || requestParameters.SessionPackage === undefined) {
            throw new runtime.RequiredError('SessionPackage','Required parameter requestParameters.SessionPackage was null or undefined when calling updateSessionPackage.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/session_packages/{session_package_id}`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"session_package_id"}}`, encodeURIComponent(String(requestParameters.session_package_id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SessionPackageToJSON(requestParameters.SessionPackage),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionPackageFromJSON(jsonValue));
    }

    /**
     * Update session-package
     */
    async updateSessionPackage(requestParameters: UpdateSessionPackageRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SessionPackage> {
        const response = await this.updateSessionPackageRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Void a session credit
     */
    async voidSessionCreditRaw(requestParameters: VoidSessionCreditRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<SessionCredit>> {
        if (requestParameters.program_id === null || requestParameters.program_id === undefined) {
            throw new runtime.RequiredError('program_id','Required parameter requestParameters.program_id was null or undefined when calling voidSessionCredit.');
        }

        if (requestParameters.session_credit_id === null || requestParameters.session_credit_id === undefined) {
            throw new runtime.RequiredError('session_credit_id','Required parameter requestParameters.session_credit_id was null or undefined when calling voidSessionCredit.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/programs/{program_id}/session_credits/{session_credit_id}/void`.replace(`{${"program_id"}}`, encodeURIComponent(String(requestParameters.program_id))).replace(`{${"session_credit_id"}}`, encodeURIComponent(String(requestParameters.session_credit_id))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SessionCreditFromJSON(jsonValue));
    }

    /**
     * Void a session credit
     */
    async voidSessionCredit(requestParameters: VoidSessionCreditRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<SessionCredit> {
        const response = await this.voidSessionCreditRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
